import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { FaqDto, SimpleTeaserDto } from 'cpes-common';
import {
    Faq as FaqShared,
    FaqLoadingPlaceholder,
    HeroImage,
    useAnalyticsActionTracker,
    useAnalyticsPageViewTracker,
} from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { prependBrandInProduction } from '../../utils';
import { useTranslation } from 'react-i18next';
import { FaqCMS } from '@cp-shared-19/apis';

const FaqView: React.FC<{ faq?: FaqDto }> = ({ faq }) => {
    const { onAction } = useAnalyticsActionTracker('onFaqQuestion');
    const { teaser } = faq || {};
    const teaserComponent = teaser ? (
        <HeroImage
            title={teaser.title}
            imageUrl={prependBrandInProduction(teaser.imageUrl)}
            shallow={true}
            inverted={!!teaser.isInverted}
            focalPoint="top-center"
        />
    ) : null;

    const { header, descriptionText, items } = faq?.content || { header: '', items: [] };

    let openItems = [];

    const handleOnChange = (refs: string[]): void => {
        if (openItems.length > refs.length || !refs.length) {
            openItems = [...refs];
            return;
        }
        openItems = [...refs];
        onAction(refs[refs.length - 1]);
    };

    const contentComponent = (
        <FaqShared onChange={handleOnChange} header={header} descriptionText={descriptionText} items={items} />
    );

    return (
        <>
            {teaserComponent}
            <ContentSection pageWrapSize="medium">{contentComponent}</ContentSection>
        </>
    );
};

const FaqWithHandlers = withLoadingAndNoConnectionHandler(FaqView);

export const Faq: React.FC = () => {
    const { t } = useTranslation('faq');
    const teaser: SimpleTeaserDto = t('teaser', { returnObjects: true });
    const content: FaqCMS = t('content', { returnObjects: true });
    teaser.imageUrl = t('teaser.image.url');
    const faq = {
        teaser: teaser,
        content: content,
    };

    useAnalyticsPageViewTracker('faq', !!faq);
    return (
        <FaqWithHandlers
            hasError={!!faq.content || !faq.teaser}
            isLoading={false}
            faq={faq}
            loadingPlaceholder={<FaqLoadingPlaceholder />}
        />
    );
};
